module.exports = __webpack_public_path__ + "static/tasks-363ee7b7ae28a82cf9f5b00b1d76eee1.png";